import {eventLoader} from '@otto-ec/global-resources/event-loader';
import GeneralInquiryStartPage from '@general_inquiry/GeneralInquiryStartPage'

eventLoader.onAllScriptsExecuted(
    10,
    () => {
        GeneralInquiryStartPage.initialize(window, document)
    }
)